export default "__VITE_ASSET__Dzccoh4M__"